import { render, staticRenderFns } from "./ImageSelectBtn.vue?vue&type=template&id=2dc75023&scoped=true"
import script from "./ImageSelectBtn.vue?vue&type=script&lang=js"
export * from "./ImageSelectBtn.vue?vue&type=script&lang=js"
import style0 from "./ImageSelectBtn.vue?vue&type=style&index=0&id=2dc75023&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc75023",
  null
  
)

export default component.exports